
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles/workspace",
      function () {
        return require("private-next-pages/profiles/workspace.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profiles/workspace"])
      });
    }
  